const utils = require("frontend-controller/lib/utils");
module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'controller',
        'controller',
    ],

    config: {
        filterTimeout: 50,
        showColorBar: true,
        tabConfigNavKey: 'employeeReports',
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_employeeReports': true,
        },
    },

    methods: {
        getResourceFilters: function(storage, resourceFilters, actionKey, fieldCode){
            if(actionKey === 'refreshResources'){
                resourceFilters = resourceFilters || {}

                if(utils.collectionSize(this.model.resourceFilters) > 0){
                    utils.refReplace(resourceFilters, this.model.resourceFilters)
                }

                this.model.resourceFilters = resourceFilters
            }

            return resourceFilters
        },

        loadResourcesGranted(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
            if(actionKey === 'refreshResources'){
                return !!((resourceFilters || {}).filters || {}).monthStartTS
            }

            return true
        },

        updateFilters(filters, forceUpdate = false){
            this.model.resourceFilters = this.model.resourceFilters || {}

            if(forceUpdate || !utils.isEqual(this.model.resourceFilters.filters || {}, filters || {})){
                this.model.resourceFilters.filters = {
                    ...(this.model.resourceFilters.filters || {}),
                    ...(filters || {})
                }

                // prevent multiple resource loading operations on init via delay
                this.delayedLastOf('refreshByFilterUpdate', async () => {
                    await this.performAction('refreshResources')
                    this.triggerFind('update', {employeeReportData: this.resourceData.data})
                }, this.config.filterDelay)
            }
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers    = this.config.heartbeatRefreshOn || {}
            const key           = message.heartbeatKey
            const myEmployeeID  = (((((storage || {}).user || {}).data || {}).userTableAssociates || {}).employee || {}).employeeID

            if(refreshers[key] && (
                (
                    key !== 'resourceChanged.bo_employeeReports'
                ) ||
                (key === 'resourceChanged.bo_employeeReports' && myEmployeeID && (message.data.employeeIDs || {})[myEmployeeID])
            )){
                this.updateFilters(false, true)
            }
        },
    },

    hooks: {
        controlsOptionsChanged($element, options){
            this.updateFilters((options || {}).options || {})
        },
    },

    handlers: [
        {
            name: 'heartbeat.resourceChanged',
            handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
                this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
            }
        },
        {
            name: 'heartbeat.reconnect',
            handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
                this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
            }
        },
    ],
}